import {remCalc} from '_themeUtils'

const switchLocaleModal = {
    SwitchLocaleModal: {
        baseStyle: () => ({
            wrapper: {
                w: '100%',
                gap: 0,
            },
            imageWrapper: {
                position: 'relative',
                w: '100%',
                pt: {base: '73.33%', md: '23.22%'},
                _before: {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 2,
                    backgroundColor: 'color.background.alpha.dark.40',
                },
            },
            bannerText: {
                position: 'absolute',
                left: '50%',
                top: '50%',
                w: {base: '75%', md: 'auto'},
                textStyle: {base: 'paragraphSm', md: 'paragraphMd'},
                lineHeight: 'spacing.6',
                letterSpacing: remCalc(0.6),
                color: 'color.text.white',
                textAlign: 'center',
                transform: 'translate(-50%, -50%)',
                zIndex: 3,
            },
            body: {
                w: '100%',
                pt: {base: 'spacing.4', md: 'spacing.10'},
                pb: 'spacing.10',
                px: 'spacing.4',
                gap: 0,
            },
            title: {
                w: '100%',
                textStyle: {base: 'paragraphLg', md: 'displayXs'},
                textAlign: 'center',
                letterSpacing: remCalc(1),
                fontWeight: 500,
                pb: {base: 'spacing.4', md: 'spacing.8'},
            },
            buttonWrapper: {
                w: '100%',
                flexDir: {base: 'column', lg: 'row'},
                flexWrap: 'wrap',
                gap: {base: 'spacing.4', lg: 'spacing.8'},
                alignItems: 'center',
                justifyContent: 'center',
                pb: {base: 'spacing.6', md: 'spacing.11'},
            },
            button: {
                textStyle: {base: 'buttonXs', md: 'paragraphMd'},
                w: {base: '100%', md: 'auto'},
                minH: {base: remCalc(42), md: remCalc(48)},
                fontWeight: 300,
                letterSpacing: remCalc(4),
                px: 'spacing.8',
                whiteSpace: 'unset',
                size: {},
            },
            switchLink: {
                textTransform: 'unset',
                fontWeight: 400,
                px: remCalc(2),
                pb: 'spacing.1',
                letterSpacing: remCalc(0.86)
            },
            selectWrapper: {
                w: '100%',
                maxW: {base: remCalc(400), md: remCalc(500)},
                m: '0 auto',
            },
            secondStepButton: {
                textStyle: 'paragraphMd',
                minH: remCalc(48),
                fontWeight: 300,
                letterSpacing: remCalc(4),
                size: {},
            },
        }),
    },
}

export default switchLocaleModal
